import { Pagination, TenantFilterTypeEnum } from '.';
import { CohortItemType } from './cohort.interface ';

export enum PartnerSponsorTypeEnum {
  Public = 'Public',
  Private = 'Private',
  Nonprofit = 'Nonprofit',
  Other = 'Other',
}

export enum PartnerResourceTypeEnum {
  ADVISORY_SERVICES = 'Advisory Services',
  BLOG_POST = 'Blog Post',
  CERTIFICATION_RESOURCES = 'Certification Resources',
  CONTRACTING_PORTAL = 'Contracting Portal',
  DIRECTORY = 'Directory',
  EDUCATIONAL_ARTICLE = 'Educational Article',
  FUNDING = 'Funding',
  GUIDEBOOK = 'Guidebook',
  LIVE_EVENT_OR_WEBINAR = 'Live Event or Webinar',
  NEWS_ARTICLE = 'News Article',
  ON_DEMAND_TRAINING = 'On-Demand Training',
  PROCUREMENT_OPPORTUNITY = 'Procurement Opportunity',
  PROGRAM = 'Program',
  RECORDED_WEBINAR = 'Recorded Webinar',
  TEMPLATE = 'Template',
  TOOL = 'Tool',
}

// This map is used to convert PartnerResourceTypeEnum to snake_case strings since API returns only values from enum
export const PartnerResourceTypeSnakeCaseMap: Record<
  PartnerResourceTypeEnum,
  string
> = {
  [PartnerResourceTypeEnum.ADVISORY_SERVICES]: 'advisory_services',
  [PartnerResourceTypeEnum.BLOG_POST]: 'blog_post',
  [PartnerResourceTypeEnum.CERTIFICATION_RESOURCES]: 'certification_resources',
  [PartnerResourceTypeEnum.CONTRACTING_PORTAL]: 'contracting_portal',
  [PartnerResourceTypeEnum.DIRECTORY]: 'directory',
  [PartnerResourceTypeEnum.EDUCATIONAL_ARTICLE]: 'educational_article',
  [PartnerResourceTypeEnum.FUNDING]: 'funding',
  [PartnerResourceTypeEnum.GUIDEBOOK]: 'guidebook',
  [PartnerResourceTypeEnum.LIVE_EVENT_OR_WEBINAR]: 'live_event_or_webinar',
  [PartnerResourceTypeEnum.NEWS_ARTICLE]: 'news_article',
  [PartnerResourceTypeEnum.ON_DEMAND_TRAINING]: 'on_demand_training',
  [PartnerResourceTypeEnum.PROCUREMENT_OPPORTUNITY]: 'procurement_opportunity',
  [PartnerResourceTypeEnum.PROGRAM]: 'program',
  [PartnerResourceTypeEnum.RECORDED_WEBINAR]: 'recorded_webinar',
  [PartnerResourceTypeEnum.TEMPLATE]: 'template',
  [PartnerResourceTypeEnum.TOOL]: 'tool',
};

export enum GeographyServeEnum {
  NATIONAL = 'National',
  STATE = 'State',
  ZIPCODESPECIFIC = 'Zip code-specific',
}

export enum BusinessStageEnum {
  PRE_STARTUP = 'PRE_STARTUP',
  STARTUP = 'STARTUP',
  OPERATING = 'OPERATING',
}
export interface PartnerResourcesItemType {
  id: number;
  partnerName: string;
  partnerAffiliation: string;
  sponsorType: PartnerSponsorTypeEnum;
  resourceType: PartnerResourceTypeEnum;
  imgUrl: string;
  outboundLink: string;
  about: string;
  geography: GeographyServeEnum;
  industries: string[];
  businessStage: BusinessStageEnum[];
  sboCommunities: string[];
  topics: string[];
  contractingNeeds: string[];
  states: string[] | null;
  zipCodes: string[] | null;
  tenantIds: number[];
  advisoryOrgId: number | null;
  fee: number;
  hasLicense: boolean;
  updatedAt: Date;
}

export interface FetchResourcesType {
  resources: PartnerResourcesItemType[];
  cohorts: CohortItemType[];
}

export type PaginatedPartnerResourcesResponseType<
  T = PartnerResourcesItemType,
> = {
  partnerResources: T[];
  count: number;
  limit: number;
  offset: number;
};
export interface PartnerResourcesSearchType extends Pagination {
  order?: string;
  filters?: string;
  parnterResourceFilter?: Object;
}

export interface PartnerResourcesChosenFilterListsType {
  topics?: string[];
  businessStage?: string[];
  sboCommunities?: string[];
  industry?: string[];
  geography?: string[];
  sponsorType?: string[];
  resourceType?: string[];
}

export type AvailablePartnerResourcesFilterOptionType =
  | 'topics'
  | 'businessStage'
  | 'sboCommunities'
  | 'industry'
  | 'geography'
  | 'contractingNeeds'
  | 'sponsorType'
  | 'resourceType';

export type PartnerResourcesFilterOptionListType = {
  availableValues: Array<string | { value: any; name: string }>;
  anyText: string;
  description?: string;
  title: string;
  phoneText?: string;
  buttonText: string;
  isMultiple: boolean;
};

export type PartnerResourcesFilterOptions = Record<
  AvailablePartnerResourcesFilterOptionType,
  PartnerResourcesFilterOptionListType
>;

export interface FetchPartnerResourcesFilterSettings {
  id: number;
  tenantId: number;
  filterType: TenantFilterTypeEnum;
  filterSetting: PartnerResourcesFilterOptions;
  isEnabled: boolean;
  filterText: string;
}
